import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isAutoScrollOn, autoScrollOn } from '../../reducers/autoScrollReducer';

const SCROLL_PER_INTERVAL_PX = 2;
let SCROLL_INTERVAL_MS = 30;
const INTERVAL = {
  slow: 100,
  normal: 60,
  fast: 10,
  default: 30,
};
function isBootomOfPageReached() {
  return (window.innerHeight + window.scrollY) >= document.body.offsetHeight;
}

function toTopOfPage() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

let scrollInterval = null;

function startScrolling() {
  scrollInterval = setInterval(() => {
    if (isBootomOfPageReached()) {
      toTopOfPage();
    }
    window.scrollBy(0, SCROLL_PER_INTERVAL_PX);
  }, SCROLL_INTERVAL_MS);
}

function stopScrolling() {
  if (scrollInterval != null) {
    clearInterval(scrollInterval);
  }
}


class KioskAutoScroll extends Component {
  componentDidMount() {
    this.setInterval();
  }

  componentWillUnmount() {
    stopScrolling();
  }

  setInterval = () => {
    const { router } = this.props;
    if (!router.location.search) {
      return;
    }
    const { search } = router.location;
    const interval = search.substring(search.indexOf('speed=') + 6, search.length);
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(interval)) {
      SCROLL_INTERVAL_MS = this.getInterval(interval);
    } else {
      SCROLL_INTERVAL_MS = interval;
    }
    if (search.indexOf('autoscroll') > -1) {
      startScrolling();
    } else {
      stopScrolling();
    }
  }

  getInterval = intervalName => (INTERVAL[intervalName] ? INTERVAL[intervalName] : INTERVAL.default)

  render() {
    const { children } = this.props;
    return (
      <div>
        {children}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isAutoScrollEnabled: isAutoScrollOn(state),
  router: state.router,
});

const mapDispatchToProps = dispatch => ({
  autoScroll: () => dispatch(autoScrollOn()),
});

KioskAutoScroll.propTypes = {
  router: PropTypes.object.isRequired,
  startScroll: PropTypes.bool.isRequired,
  autoScroll: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(KioskAutoScroll);



// WEBPACK FOOTER //
// ./src/components/KioskAutoScroll/KioskAutoScroll.jsx